// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2d2a47fd","453":"c9096ce2","455":"e6c0459d","977":"7659eec6"}[chunkId] + ".chunk.js";
};